import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const busApi = createApi({
  reducerPath: "busApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/buses`,
  }),
  tagTypes: ["Buses"],
  endpoints: (builder) => ({
    getBuses: builder.query<any[], void>({
      query: () => "/",
      providesTags: ["Buses"],
    }),
    createBus: builder.mutation<any, any>({
      query: (bus) => ({ url: "/", method: "POST", body: bus }),
      invalidatesTags: ["Buses"],
    }),
    updateBus: builder.mutation<any, { id: string; bus: any }>({
      query: ({ id, bus }) => ({ url: `/${id}`, method: "PUT", body: bus }),
      invalidatesTags: ["Buses"],
    }),
    deleteBus: builder.mutation<any, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["Buses"],
    }),
  }),
});

export const {
  useGetBusesQuery,
  useCreateBusMutation,
  useUpdateBusMutation,
  useDeleteBusMutation,
} = busApi;
